import React, {useState, useEffect} from "react";
import Slider from "react-slick";
import { siteUrl } from '../../../shared/utils/siteUrl';
import "./section-how-entry.scss";
import ReminderCard from '../../atoms/reminder-card/reminder-card';
import StepsEntryItem from '../../atoms/steps-entry-item/steps-entry-item';

const SectionHowEntry = ({ mobile }) => {
    const [pageLoad, setpageLoad] = useState(false)
    const [howEntry, sethowEntry] = useState(false)

    useEffect(() => {
        setpageLoad(true)
        if(localStorage.getItem('TOKEN_INFO')){
            window.location.href = siteUrl + '/mis-puntos/que-puedo-ganar'
        }
    }, [])

    var settings = {
        slidesToShow: (mobile ? 1 : 3),
        dots: mobile ? true : false,
        slidesToScroll: 1,
        infinite: true
    };

    if (pageLoad && mobile && !howEntry) {
        sethowEntry(true)
        setTimeout(() => {
          window.scrollTo(0, 700);
        }, 200);
      };
      if (pageLoad && !mobile && !howEntry) {
        sethowEntry(true);
        setTimeout(() => {
          window.scrollTo(0, 510);
        }, 200);
      };

    return (
        <div className="f-section-how-entry-container">
            <span className="f-curve-effect-how-entry" >
                <span className="f-circle-how-entry" />
            </span>            
            <div className="f-section-how-entry-container-wrap">
                <div className="f-info-container">
                    <div className="f-info-container-title">
                        <h2>¿Cómo ingreso las claves?</h2>
                    </div>
                    <Slider {...settings} className="f-carousel-steps-entry-keys">
                        <StepsEntryItem
                            title="1"
                            imgUrl={(process.env.LOCALE === "es-UY" || process.env.LOCALE === "es-AR" || process.env.LOCALE === "es-PY") ? require('../../../assets/images/paso-1-UY.png') : require('../../../assets/images/paso-1.png')} 
                            description={`${(process.env.LOCALE === "es-UY" || process.env.LOCALE === "es-AR" || process.env.LOCALE === "es-PY") ? 'Registrate' : 'Regístrate'} o inicia sesión en NosotrasOnline.`}
                        />
                        <StepsEntryItem
                            title="2"
                            imgUrl={(process.env.LOCALE === "es-UY" || process.env.LOCALE === "es-AR" || process.env.LOCALE === "es-PY") ? 
                            require('../../../assets/images/paso-2-UY.png') : 
                            process.env.LOCALE === "es-CL" ? 
                            require('../../../assets/images/paso-2-CL.png') : 
                            require('../../../assets/images/paso-2.png')} 
                            description={`Ingres${(process.env.LOCALE === "es-UY" || process.env.LOCALE === "es-AR" || process.env.LOCALE === "es-PY") ? 'á' : 'a'} la clave personal que viene al respaldo o laterales de tus productos Nosotras.`}
                        />
                        <StepsEntryItem
                            title="3"
                            imgUrl={require('../../../assets/images/paso3.png')}
                            description="Al ingresar la clave  personal no debes utilizar espacios, puntos o guiones."
                        />
                    </Slider>
                </div>
                <ReminderCard mobile={mobile} />
            </div>            
        </div>
    )
}

export default SectionHowEntry;